import { ToggleSwitch, ToggleSwitchChangeEvent } from 'primeng/toggleswitch';

import { CommonModule } from '@angular/common';
import { Input, Component, forwardRef } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';

import { ControlValueAccessorComponent } from '@/app/shared/components/ControlValueAccessorComponent';

@Component({
  selector: 'app-toggle-switch',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ToggleSwitch],
  templateUrl: './toggle-switch.component.html',
  styleUrl: './toggle-switch.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ToggleSwitchComponent),
      multi: true,
    },
  ],
})
export class ToggleSwitchComponent extends ControlValueAccessorComponent {
  @Input()
  public disabled: boolean = false;

  @Input()
  public readonly: boolean = false;

  @Input()
  public label: string | undefined = undefined;

  protected onInputValueChange(event: ToggleSwitchChangeEvent): void {
    this.value = event.checked;

    this.onValueChange(this.value);
  }
}
